<template>
	<div class="profile-panel">
		<el-dropdown @command="openProfile" placement="bottom" trigger="click">
			<span class="el-dropdown-link">
				<i class="icon icon-personal"></i>
				<span>{{ nickname }}</span>
				<i class="el-icon-arrow-down el-icon--right"></i>
			</span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item command="panel">
					<div class="panel">
						<p class="panel-name">{{ nickname }}</p>
						<span>{{ $t(role) }}</span>
					</div>
				</el-dropdown-item>
				<!-- <el-dropdown-item command="settings" divided>
					<i class="icon icon-setting"></i>
					<span>{{$t('settings')}}</span>
				</el-dropdown-item>-->
				<el-dropdown-item command="logout">
					<i class="icon icon-logout"></i>
					<span>{{$t('logout')}}</span>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'profile-panel',
	computed: {
		...mapGetters(['nickname', 'role'])
	},
	methods: {
		...mapActions(['logout']),
		openProfile(command) {
			if (command === 'logout') {
				this.$router.replace({ path: '/logout' });
			} else if (command === 'settings') {
				this.$router.push({
					name: 'settings'
				});
			}
		}
	}
};
</script>


<style lang="scss" scoped>
.profile-panel {
	padding-left: 15px;
	i {
		cursor: pointer;
	}
}
.panel {
	// text-align: center;
	line-height: 1.5;
	.panel-name {
		padding: 5px 0;
		font-size: $-font-size-m;
		color: $-color-text-secondary;
	}
}
</style>
